export default __webpack_public_path__ + "28bf80e39ebb3de5d011645f05146e32.svg";